import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ProjectErrorHandlerService, ProjectService, SessionService } from '@newroom-connect/library/services';
import { take, catchError, of, switchMap } from 'rxjs';

import { NavigationService } from '../../services/navigation.service';

export const IsProjectActiveGuard: CanActivateFn = (route) => {
  const projectErrorHandlerService = inject(ProjectErrorHandlerService);
  const projectService = inject(ProjectService);
  const sessionService = inject(SessionService);
  const navigationService = inject(NavigationService);

  const projectSlug = route.params['projectSlug'];

  return projectService.getProjectBySlug(projectSlug).pipe(
    take(1),
    catchError(() => {
      navigationService.navigateTo404();
      return of(null);
    }),
    switchMap(project => {
      if (!project) {
        return of(false);
      }

      const notStarted = !projectService.isProjectStarted(project);
      const alreadyEnded = projectService.isProjectEnded(project);

      if (notStarted || alreadyEnded) {
        // Force clear user session if the project is not active.
        sessionService.clearUserSession();

        projectErrorHandlerService.handleIsProjectActiveError(
          notStarted ? 'ERROR.PROJECT_NOT_STARTED' : 'ERROR.PROJECT_ALREADY_FINISHED'
        );
      }

      return of(!notStarted && !alreadyEnded);
    })
  );
};
